var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-features"},[_c('introduce'),_c('painPoint'),_c('ability'),_c('trial')],1)}
var staticRenderFns = []

export { render, staticRenderFns }